export default __webpack_public_path__ + "0006d5e9190f62a9afe4a7cd42fd298f.png";